export default __webpack_public_path__ + "9f2d3f2715657f7ff088be9f5e2511a0.svg";